(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'applicationinstruction', {
            bindings: {
            },
            templateUrl:  'app/views/partials/content/application-instruction.html',
            controllerAs: 'vm',
            controller:   ApplicationInstructionController,
        });


    /**
     * Renders plain content paragraph with `applicationInstructions` HTML data
     * retrieved from the International API. The programme code for which the
     * data will be retrieved is automatically determined by the code from the
     * closest ancestor (be it a programme or sub-programme).
     *
     * @param {ng.IScope} $scope
     * @param {DataService} DataService
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {LoggerFactory} LoggerFactory
     * @param {Utils} Utils
     */
    function ApplicationInstructionController(
        $scope,
        DataService,
        ContentSwitchingService,
        LoggerFactory,
        Utils
    ) {

        // Helper members.

        /** @type {angular.IController} */
        var vm = this;



        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'ApplicationInstructionController', false );


        /** @constant */
        var PROGRAMME_CODE;



        /* ===== RUN ON INSTANTIATION =================================== */


        /** @constructor */
        vm.$onInit = function() {
            initDependencies();
            setWatchers();
        }





        /* ===== PRIVATE FUNCTIONS ====================================== */


        function initDependencies() {
            PROGRAMME_CODE = Utils.retrieveMetadataRecursively( $scope, 'internationalApiCode' );
        }


        function setWatchers() {
            $scope.$watch( function(){ return ContentSwitchingService.userSettings.lastStudyCountry.code }, function( newLastStudyCountry ) {

                if ( newLastStudyCountry ) {
                    logger.debug( "Preferred last country of study has changed, re-rendering application instructions block." );
                    updateApplicationInstructions();
                }
            });
        }


        function updateApplicationInstructions() {
            // Fetch the programme info and the application instructions in it
            DataService.getInternationalProgramme( PROGRAMME_CODE, ContentSwitchingService.userSettings.lastStudyCountry.code ).then(function( programmeResponse ){
                if ( programmeResponse
                    && programmeResponse.data.programme
                    && programmeResponse.data.programme.applicationInstruction ) {
                    vm.content = programmeResponse.data.programme.applicationInstruction;
                } else {
                    // No specific application instruction is available - log it to get that fixed!
                    vm.content = undefined;
                    logger.warn( "The programme with international API code `%s` has not received any `applicationInstruction` in the international API response. The application instruction block will not be rendered.", PROGRAMME_CODE );
                }
            }, function( error ) {
                logger.error( "Unable to render application instructions for programme with international API code `%s`. Probably a problem with international API responding or component rendering.", PROGRAMME_CODE, error );
            });
        }
    }


    ApplicationInstructionController.$inject = [ '$scope', 'DataService', 'ContentSwitchingService', 'LoggerFactory', 'Utils' ];
})();
